import { useCookies } from "vue3-cookies";
import { apiCall } from '@/shared/services/apiCall' // IMPORT GLOBAL API INSTANCE
import { errorToast } from '@/shared/services/helper.js'
const { cookies } = useCookies();
import { setHeaders } from "@/shared/services/headers";
import store from "@/store";

const walletRoutes = ['Wallet', 'wallet-deposit', 'wallet-withdraw', 'wallet-history', 'wallet-history-detail', 'payment-method', 'deposit-payment-method', 'add-account', 'TransactionDetails'];

const setUserDataToStore = async (userData) => {
    let user = {
        notificationSubscribed: null,
        notificationUnsubscribed: null,
        isDemo: userData?.demo || false
    }
    store.dispatch('setUser', { ...userData?.user, ...user });
    store.dispatch('setChips', userData?.user?.chips);
    store.dispatch('setEventManage', userData?.event_manage);
};

const getMultiTemplateAuth = async (routeData) => {
    try {
        window.authorization_token = `Bearer ${routeData.query.auth}`;
        store.dispatch('setToken', `Bearer ${routeData.query.auth}`);
        setHeaders();
        let response = await apiCall('get', 'GET_USER_INFO');
        if (response && response.status == 200) {
            if (response?.data?.status == 0 || response?.data?.error || response?.data?.msg) {
                errorToast(response?.data?.error);
            } else {
                setUserDataToStore(response.data);
                store.state.auth.user.token = routeData.query.auth;
            }
        }
        return
    }
    catch (error) {
        console.log(error);
        errorToast(error || 'Something went wrong')
    }
};

window.addEventListener('popstate', (event) => {
    if (document.querySelector('.modal.show')) {
        window.location.reload();
    }
});

export const routerGuard = async (to, from, next) => {
    const auth = store.getters.isAuthenticated;
    const underMaintenance = store.getters.underMaintenance;
    const isMaintenancePage = to.name === 'Maintenance';
    const lastLoginAt = window.store?.getters?.stateUser?.last_login_at;


    if (to.query.auth && !auth) {
        await getMultiTemplateAuth(to);
        cookies.set('AUTH_TOKEN', to.query.auth);
        return next({ name: 'Home' })
    }
    if (document.querySelector('.modal.show')) {
        next(false);
        return;
    }

    let backgroundImage = '';
    let darkImageRoutes = [
        'profile',
        'change-password',
        'messages',
        'promotions',
        'account-info',
        'my-bets',
        'profit-loss',
        'account-statement',
        'bonus',
    ]

    if (to.name == 'login' || to.name == 'sign-up' || to.name == 'forget-password') {
        backgroundImage = 'url(' + require('@/assets/images/IPLAuthBgEngSmallerDevices.webp') + ')';
    }
    else if (darkImageRoutes.includes(to.name)) {
        backgroundImage = backgroundImage = 'url(' + require('@/assets/images/memberLayoutBGNew.webp') + ')';
    }
    else {
        backgroundImage = backgroundImage = 'url(' + require('@/assets/images/mobileMainBg.webp') + ')';
    }
    document.body.style.backgroundImage = backgroundImage;

    if (auth.user?.isDemoLogin && walletRoutes.includes(to.name)) {
        errorToast('Wallet Access Is Restricted For Demo User.');
        next({ name: 'Home' });
    }
    else if (window.store.getters.siteSettings?.business_type != 2 && walletRoutes.includes(to.name)) {
        errorToast('Wallet Access Is Restricted.');
        next({ name: 'Home' });
    }
    else if (window.store.getters.siteSettings?.business_type != 2 && to.name === 'refer-earn') {
        errorToast('Refer And Earn access Is Restricted.');
        next({ name: 'Home' });
    }
    else {
        next();
    }

    if (document.querySelector('.modal.show')) {
        next(false);
        return;
    }

    if (underMaintenance) {
        if (!isMaintenancePage) {
            next({ name: 'Maintenance' });
        } else {
            next();
        }
    } else if ((to.name == 'login' || to.name == 'sign-up' || to.name == 'forget-password') && auth) {
        next({ name: 'Home' });
    } else {
        if (isMaintenancePage) {
            next({ name: 'Home' });
        } else if (auth && !lastLoginAt && to.name !== 'change-password') {
            next({ name: 'change-password' });
            return
        } else {
            let openModal = document.querySelector('.modal.show');
            if (openModal) {
                next(false);
            } else {
                next();
            }
        }
    }
};